import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl"
//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    Button,
    Input,
    Select,
    RadioButton
} from "@gpstrackit/react-controls";
import { Grid } from "@mui/material";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    createUnsubscribedContactRequest,
    clearRedux,
} from 'Redux/actions';

import countries from './countries.json';

const CreateUnsubscribedContact = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef();

    const { dealers, dealersLoading } = useSelector(state => state.generalRedux);


    const [via, setVia] = useState("Email");
    const [to, setTo] = useState(null);
    const [country, setCountry] = useState({
        "name": "United States",
        "id": "1",
        "code": "US"
    })
    const [reason, setReason] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null);

    const {
        loading,
        createdUnsubscribedContact,
        updateUser,
        openModal,
        roles,
        getUserLoading,
        user,
        currentId,
    } = useSelector(state => state.createUnsubscribedContactRedux)

    const closeModal = () => {
        dispatch(clearRedux("UNSUBSCRIBED_CONTACT_CREATE"));
        setVia("Email");
        setTo(null);
        setCountry({
            "name": "United States",
            "id": "1",
            "code": "US"
        });
        setReason(null);

    }

    const saveUnsubscribedContact = () => {
        let error = false
        if (via === "SMS" && (!to || to.length < 10 || to.length > 10)) {
            error = true
        }
        if (!error)
            dispatch(createUnsubscribedContactRequest({
                to: via === "SMS" ? `sms_${country.id}${to}` : `email_${to}`,
                source: "manual",
                reason
            }));
        else
            setErrorMessage(messages["create_unsubscribed_contact_required_phone"])

        return error
    }

    useEffect(() => {
        if (createdUnsubscribedContact && !createdUnsubscribedContact?.error) {
            tableRef?.current?.getData();
            NotificationManager.success(
                messages['create_unsubscribed_contact_has_been_created'],
                messages['create_unsubscribed_contact_title'],
                3000
            );
            closeModal();
            dispatch(clearRedux("UNSUBSCRIBED_CONTACT_CREATE", { createdUnsubscribedContact: null }))
        } else if (createdUnsubscribedContact && createdUnsubscribedContact?.error) {
            NotificationManager.error(
                createdUnsubscribedContact?.errorMessage || messages['create_unsubscribed_contact_error_create'],
                messages['create_unsubscribed_contact_title'],
                3000
            );
            dispatch(clearRedux("UNSUBSCRIBED_CONTACT_CREATE", { createdUnsubscribedContact: null }))
        }

    }, [createdUnsubscribedContact]);

    useEffect(() => {
        if (!openModal) closeModal();
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={messages['create_unsubscribed_contact_title']}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 36 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => saveUnsubscribedContact()}
                        autocomplete="nope"
                    >
                        <Grid item xs={12}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1" style={{ marginRight: 5 }}>{messages['create_unsubscribed_contact_via']}</label>
                                <RadioButton
                                    onChange={() => {
                                        setVia('Email');
                                        setTo(null)
                                    }}
                                    value={via === 'Email'}
                                    label={messages['create_unsubscribed_contact_via_email']}
                                    position="end"
                                />
                                <RadioButton
                                    onChange={() => {
                                        setVia('SMS');
                                        setTo(null)
                                    }}
                                    value={via === 'SMS'}
                                    label={messages['create_unsubscribed_contact_via_sms']}
                                    position="end"
                                />
                            </div>
                        </Grid>
                        {
                            via === "Email" &&
                            <div style={{ marginTop: 5 }}>
                                <Input
                                    type="email"
                                    label={messages['create_unsubscribed_contact_email']}
                                    placeholder={messages['create_unsubscribed_contact_email']}
                                    value={to || ""}
                                    onChange={(value) => setTo(value)}
                                    requiredMessage={messages['required_field']}
                                    email
                                    emailMessage={messages['create_unsubscribed_contact_email_is_invalid']}
                                    required
                                    autoComplete="off"
                                />
                            </div>
                        }
                        {
                            via === "SMS" &&
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                spacing={1}
                                style={{
                                    marginBottom: 1
                                }}
                            >

                                <Grid item xs={4}>
                                    <Select
                                        id="country"
                                        value={country || null}
                                        label={messages['create_unsubscribed_contact_phone_number']}
                                        loading={loading}
                                        style={{ width: 110 }}
                                        onChange={(newValue) => {
                                            setCountry(newValue);
                                        }}
                                        getOptionLabel={(opt) => `${opt?.code} (+${opt?.id})`}
                                        options={countries}
                                        valueField="id"
                                        textField="code"
                                        required
                                        requiredMessage={messages['required_field']}
                                    />
                                </Grid>

                                <Grid item xs={8}>
                                    <Input
                                        id="sms"
                                        type="number"
                                        label={<br />}
                                        placeholder={messages['create_unsubscribed_contact_phone_number']}
                                        value={to || ""}
                                        onlyPositive
                                        onChange={(newValue) => {
                                            setTo(newValue);
                                        }}
                                        minLength={10}
                                        maxLength={10}
                                        minLengthMessage={messages['create_unsubscribed_contact_required_phone']}
                                        maxLengthMessage={messages['create_unsubscribed_contact_required_phone']}
                                    />
                                </Grid>
                                {
                                    errorMessage &&
                                    <small className="text-danger" style={{ paddingTop: 5 }}>
                                        {errorMessage}
                                    </small>
                                }
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <Input
                                id="reason"
                                type="text"
                                label={messages['create_unsubscribed_contact_reason']}
                                placeholder={messages['create_unsubscribed_contact_reason']}
                                value={reason || ""}
                                onlyPositive
                                onChange={(newValue) => {
                                    setReason(newValue);
                                }}
                                minLength={0}
                                maxLength={50}
                                style={{ marginTop: 10 }}
                            />
                        </Grid>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            setErrorMessage("")
                            formRef.current?.submit()
                        }}
                    >
                        {messages['save']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default CreateUnsubscribedContact;